// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"66512e1f","453":"3b956df4","454":"621e60d2"}[chunkId] + ".chunk.js";
};